import * as React from "react";

export const SvgSuitesAndFacilities = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={45} height={44} fill="none" {...props}>
		<circle cx={22.5} cy={22} r={21.5} fill="#fff" stroke="#FFB11A" />
		<path
			fill="#FFB11A"
			d="M32.145 26v-.99l-1.798-1.75-.18-.175-.004-.252a226.99 226.99 0 0 0-.017-1.326c-1.227-1.747-2.733-3.001-4.479-3.73-1.409-.589-2.551-.652-2.977-.652a2.521 2.521 0 0 0-.188.004h-.046a2.474 2.474 0 0 0-.142-.004c-.425 0-1.568.063-2.977.652-1.745.729-3.25 1.983-4.479 3.73-.005.268-.011.823-.017 1.326l-.002.252-.181.176-1.799 1.75v3.682h4.81v-5.222h9.668v5.222h4.808V26Zm-7.43-5.508a.087.087 0 0 1-.088.088h-4.25a.087.087 0 0 1-.087-.088v-.817c0-.048.039-.087.087-.087h4.25c.049 0 .088.04.088.087v.817Z"
		/>
		<path
			fill="#FFB11A"
			d="M31.978 20.655C31.082 19.198 28.09 15.096 22.5 15c-5.59.096-8.582 4.198-9.477 5.655l.038 1.065-1.37 1.325a.595.595 0 0 0-.191.436v1.44a.236.236 0 0 0 .402.169l2.33-2.269s.017-1.507.024-1.517a12.273 12.273 0 0 1 2.143-2.416c2.584-2.212 5.202-2.374 5.913-2.374a3.293 3.293 0 0 1 .188.004h.014c.026-.002.085-.004.174-.004.711 0 3.328.162 5.912 2.374a12.273 12.273 0 0 1 2.144 2.416c.007.01.023 1.517.023 1.517L33.1 25.09a.236.236 0 0 0 .401-.17v-1.439a.594.594 0 0 0-.19-.436l-1.334-1.29.002-1.1Z"
		/>
	</svg>
);
